import { del, delWithBody, get, getWithParams, post, put } from "../../utils/fetchAPI";

// Doctor's SIG presets per generic. `generic` = exact generic (SIG form lookup),
// `generics` = several exact generics (search results), `search` = partial generic (settings list).
export const getGenericSigs = async (doctorId, { generic, generics, search } = {}) => {
    const params = {};
    if (generic) params.generic = generic;
    if (generics?.length) params.generics = generics;
    if (search) params.search = search;
    const res = await getWithParams(`/doctor/generic-sig/list/${doctorId}`, params);
    return res;
};

export const createGenericSig = async (payload) => {
    // payload: { doctorId, generic, form, take, route, frequency, instruction, sig, duration, language }
    const res = await post(`/doctor/generic-sig`, payload);
    return res;
};

export const updateGenericSig = async (genericSigId, doctorId, payload) => {
    const res = await put(`/doctor/generic-sig/${genericSigId}?doctorId=${doctorId || ""}`, payload);
    return res;
};

export const deleteGenericSig = async (genericSigId, doctorId) => {
    const res = await del(`/doctor/generic-sig/${genericSigId}?doctorId=${doctorId || ""}`);
    return res;
};

// ---- one SIG across the generics it is tagged to ----

// Tag a SIG to several generics -> { created: [presets], rejected: [generic names] }
export const tagGenericSig = async (payload) => {
    // payload: { doctorId, generics: [..], form, take, route, frequency, instruction, sig, duration }
    const res = await post(`/doctor/generic-sig/bulk`, payload);
    return res;
};

// Edit a SIG for all its generics. match = { form, sig, duration } of the SIG as it
// is now; the server finds every preset of it.
export const updateGenericSigs = async (doctorId, match, payload) => {
    const res = await put(`/doctor/generic-sig/bulk`, { ...payload, doctorId, match });
    return res;
};

// Remove a SIG from all its generics
export const deleteGenericSigs = async (doctorId, match) => {
    const res = await delWithBody(`/doctor/generic-sig/bulk`, { doctorId, match });
    return res;
};

// The presets (= generic tags) behind one SIG
export const getGenericSigsBySig = async (doctorId, { form, sig, duration }) => {
    const res = await post(`/doctor/generic-sig/by-sig`, { doctorId, form, sig, duration });
    return res;
};

// ---- settings summaries (small however many presets the doctor has) ----

// [{ generic, count }]
export const getGenericSigGenerics = async (doctorId) => {
    const res = await get(`/doctor/generic-sig/generics/${doctorId}`);
    return res;
};

// Distinct SIGs, most used first (top 300; `search` filters on the SIG text):
// [{ form, sig, duration, take, route, frequency, instruction, language, usage, genericCount }]
export const getGenericSigSigs = async (doctorId, search) => {
    const res = await getWithParams(`/doctor/generic-sig/sigs/${doctorId}`, search ? { search } : {});
    return res;
};

// Seed presets from the doctor's My Drug List and past visits -> { created }
export const importGenericSigs = async (doctorId) => {
    const res = await post(`/doctor/generic-sig/import`, { doctorId });
    return res;
};

// Distinct generic names from the master medicine list.
export const searchGenerics = async (search) => {
    const res = await get(`/medicine/generic-list?search=${encodeURIComponent(search || "")}`);
    return res;
};
